enum Feature {
  // Application Access
  hivebriteAccess = "hivebriteAccess",
  landFundAccess = "landFundAccess",
  landInsightAccess = "landInsightAccess",

  // Alerts
  ownershipChangeAlerts = "ownershipChangeAlerts", // UK - unlimited
  planningAlerts = "planningAlerts", // UK - unlimited

  // General
  sitesRoute = "sitesRoute", // Generic - free
  mapRoute = "mapRoute", // Generic - free
  dashboardRoute = "dashboardRoute", // Generic - free
  upgradeButton = "upgradeButton", // Generic - free
  ukLocationSearch = "ukLocationSearch", // UK - free
  usAccess = "usAccess", // US - free
  usLocationSearch = "usLocationSearch", // US - free

  // Map
  showLayers = "showLayers", // Generic - starter
  showSubNavigationBar = "showSubNavigationBar", // Generic - starter
  comparablesCalculator = "comparablesCalculator", // Generic - unlimited
  unlimitedOwnershipClicks = "unlimitedOwnershipClicks", // Generic - unlimited
  unlimitedPlanningClicks = "unlimitedPlanningClicks", // UK - pro
  planningFilters = "planningFilters", // UK - pro
  permitStatusFilters = "permitStatusFilters", // US - pro
  permitAllFilters = "permitAllFilters", // US - unlimited
  ultimateOwner = "ultimateOwner", // UK - unlimited
  zooplaLightAccess = "zooplaLightAccess", // UK - unlimited

  // Assessment
  detailsTab = "detailsTab", // Generic - free
  planningHistoryTab = "planningHistoryTab", // UK - starter
  policiesTab = "policiesTab", // UK - starter
  environmentalTab = "environmentalTab", // UK - starter
  compsTab = "compsTab", // UK - starter
  powerTab = "powerTab", // UK - starter
  permitsTabUS = "permitsTabUS", // US - starter
  planningHistorySummary = "planningHistorySummary", // UK - unlimited
  policiesTabUS = "policiesTabUS", // US - starter
  environmentalTabUS = "environmentalTabUS", // US - starter
  compsTabUS = "compsTabUS", // US - starter
  utilitiesTabUS = "utilitiesTabUS", // US - starter
  hideUpgradeMarketing = "hideUpgradeMarketing", // US - unlimited
  insightsSummary = "insightsSummary", // Generic - free

  // Map layers
  sitesLayer = "sitesLayer", // Generic - free
  ownershipLayer = "ownershipLayer", // Generic - free
  pricepaidLayer = "pricepaidLayer", // Generic - starter
  comparablesPpSqftMode = "comparablesPpSqftMode", // Generic - pro
  planningLayer = "planningLayer", // UK - starter
  propertyInformationLayer = "propertyInformationLayer", // UK - starter
  amenitiesBundle = "amenitiesBundle", // UK - unlimited
  planningPolicyLayer = "planningPolicyLayer", // UK - unlimited
  powerLayer = "powerLayer", // UK - unlimited
  amenitiesLayerUS = "amenitiesLayerUS", // US - starter
  buildingPermits = "buildingPermits", // US - starter
  demographics = "demographics", // US - starter
  flumLayer = "flumLayer", // US - starter
  geologyLayer = "geologyLayer", // US - starter
  hazardsLayer = "hazardsLayer", // US - starter
  isochroneLayer = "isochroneLayer", // US - starter
  utilitiesLayerUS = "utilitiesLayerUS", // US - starter
  zoningLayer = "zoningLayer", // US - starter
  listedBuildingsStandaloneLayer = "listedBuildingsStandaloneLayer", // UK - starter/pro, but NOT unlimited
  topographyUS = "topographyUS", // US - starter
  topographyUK = "topographyUK", // UK - unlimited
  roadsAndTrafficLayer = "roadsAndTrafficLayer", // UK - unlimited
  adoptedRoadsLayer = "adoptedRoadsLayer", // UK - unlimited

  // Search
  multiFilterSearch = "multiFilterSearch", // Generic - unlimited
  ownershipSearch = "ownershipSearch", // Generic - unlimited
  sourcingToolCSVExport = "sourcingToolCSVExport", // Generic - unlimited
  planningSearch = "planningSearch", // UK - unlimited
  propertySearch = "propertySearch", // UK - unlimited

  // Sites
  siteCardActivity = "siteCardActivity", // Generic - starter
  siteReport = "siteReport", // Generic - starter
  bulkLetterSending = "bulkLetterSending", // Generic - unlimited
  letterSending = "letterSending", // Generic - unlimited
  ownershipCSVExport = "ownershipCSVExport", // Generic - unlimited
  siteBoundaryExport = "siteBoundaryExport", // Generic - UK pro and Unlimited and US free
  documentPurchase = "documentPurchase", // UK - starter
  premiumSiteCard = "premiumSiteCard", // UK - starter
  physicalSend = "physicalSend", // Generic - unlimited
  siteUtilitiesReports = "siteUtilitiesReports", // UK - unlimited
  ultimateSiteCard = "ultimateSiteCard", // UK - unlimited
  usComparablesAccess = "usComparablesAccess", // US - pro
  usOwnershipAccess = "usOwnershipAccess", // US - pro
  skipTracing = "skipTracing", // US - unlimited
  shareSiteBasic = "shareSiteBasic", // Generic - free
  shareSiteFull = "shareSiteFull", // Generic - UK unlimited and US free
  workspaceBasic = "workspaceBasic", // Generic - pro
  workspaceFull = "workspaceFull", // Generic - unlimited

  // Addons
  zooplaCompsCalculatorExport = "zooplaCompsCalculatorExport", // UK - LI-zoopla-addon
  zooplaFullAccess = "zooplaFullAccess", // UK - LI-zoopla-addon
  constraintsAdminLayer = "constraintsAdminLayer", // UK - Constraints-admin

  // Beta
  compsCalcDownloadFilter = "compsCalcDownloadFilter",
  debugMenu = "debugMenu",
  disableDatadogRum = "disableDatadogRum",
  disableGeofence = "disableGeofence",
  disableUseDevicePixels = "disableUseDevicePixels",
  integrationsDashboardBeta = "integrationsDashboardBeta",
  TURTLES = "TURTLES",
  XDOG = "XDOG",
  showDisabledInsights = "showDisabledInsights",
  insightsColumns = "insightsColumns",
  fundingBeta = "fundingBeta",
  esBasedPlanningBeta = "esBasedPlanningBeta",
  noSiteLettersInSite = "noSiteLettersInSite", // Testing blank pipeline bug
  hometrackv2 = "hometrackv2",
  aiChatBeta = "aiChatBeta",
  aiLocalPlanBeta = "aiLocalPlanBeta",
  aiSiteSourcingBeta = "aiSiteSourcingBeta",
  addonUpgradeBeta = "addonUpgradeBeta",
  rdsSwitchBeta = "rdsSwitchBeta",
  rdsWriteBeta = "rdsWriteBeta",
  pipelineCacheBeta = "pipelineCacheBeta", // pipeline cache beta
  reactMapBeta = "reactMapBeta",
  projectsBeta = "projectsBeta",

  // TODO This is set up as a beta feature, but it appears as though it was
  // intended to be an actual starter licence feature.
  usSitePlanApplicationsLayer = "usSitePlanApplicationsLayer", // US - starter

  // Performance betas
  perfDebugMenu = "perfDebugMenu",
  serverIntersectionQueryBeta = "serverIntersectionQueryBeta",

  aiPlanningSummaryBeta = "aiPlanningSummaryBeta",
}

export default Feature;
